import { Link } from "react-router-dom";
import { HERO_STORY, SECONDARY_STORIES, COLUMNS } from "../../../mocks/mockContent";
import { formatCount } from "../../../utils/format";
import Reveal from "../../../components/feature/Reveal";

const chips = COLUMNS.filter((c) => c.key !== "all");

export default function Hero() {
  return (
    <section aria-label="今日头条" className="relative overflow-hidden bg-background-50">
      {/* faint decorative gradient */}
      <div
        className="pointer-events-none absolute inset-0"
        style={{
          background:
            "radial-gradient(1200px 520px at 85% -10%, oklch(var(--accent-100)/0.7), transparent 60%), radial-gradient(900px 500px at 0% 20%, oklch(var(--primary-100)/0.5), transparent 55%)",
        }}
      ></div>

      <div className="relative mx-auto max-w-6xl px-4 pb-10 pt-8 md:px-6 md:pt-12">
        {/* ticker band */}
        <div className="mb-8 flex flex-col gap-2 border-y hairline py-3 sm:flex-row sm:items-center sm:gap-4">
          <span className="inline-flex shrink-0 items-center gap-1.5 text-sm font-semibold text-primary-700">
            <i className="ri-flashlight-fill" aria-hidden="true"></i>
            今日要瓜
          </span>
          <div className="flex flex-wrap items-center gap-x-3 gap-y-1 text-sm text-foreground-600">
            <Link to="/read/102" className="truncate transition-colors hover:text-primary-700">新剧杀青路透刷屏，主创深夜发文感谢观众</Link>
            <span className="text-background-300">·</span>
            <Link to="/read/106" className="truncate transition-colors hover:text-primary-700">演唱会门票开售即罄</Link>
            <span className="text-background-300">·</span>
            <Link to="/read/103" className="truncate transition-colors hover:text-primary-700">年度黑马综艺口碑爆棚</Link>
          </div>
        </div>

        {/* headline hero */}
        <div className="grid items-center gap-8 lg:grid-cols-12">
          <Reveal className="lg:col-span-6">
            <div className="flex items-center gap-2">
              <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-500 px-3 py-1 text-xs font-semibold text-background-50">
                <i className="ri-quill-pen-line" aria-hidden="true"></i>
                {HERO_STORY.kicker}
              </span>
              <span className="text-xs text-foreground-400">{HERO_STORY.date}</span>
            </div>

            <h1 className="mt-5 font-display text-3xl font-bold leading-snug text-foreground-950 md:text-[2.6rem] md:leading-[1.18]">
              {HERO_STORY.title}
            </h1>

            <p className="mt-5 max-w-xl text-[15px] leading-7 text-foreground-600">
              {HERO_STORY.summary}
            </p>

            <div className="mt-6 flex flex-wrap items-center gap-3">
              <Link
                to={`/read/${HERO_STORY.id}`}
                className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                阅读全文
                <i className="ri-arrow-right-line" aria-hidden="true"></i>
              </Link>
              <span className="inline-flex items-center gap-1.5 whitespace-nowrap text-sm text-foreground-500">
                <i className="ri-eye-line" aria-hidden="true"></i>
                {formatCount(HERO_STORY.read)} 人已读
              </span>
            </div>

            <div className="mt-7 flex flex-wrap items-center gap-2">
              {chips.map((c) => (
                <Link
                  key={c.key}
                  to={`/rexun?cat=${encodeURIComponent(c.key)}`}
                  className="whitespace-nowrap rounded-full border border-background-300 bg-background-50 px-3 py-1 text-xs text-foreground-600 transition-colors hover:border-primary-300 hover:text-primary-700"
                >
                  #{c.name}
                </Link>
              ))}
            </div>
          </Reveal>

          <Reveal className="lg:col-span-6" delay={120}>
            <figure className="relative overflow-hidden rounded-2xl">
              <img
                src={HERO_STORY.cover}
                alt={HERO_STORY.title}
                className="h-64 w-full object-cover object-top md:h-[380px]"
              />
              <figcaption className="absolute bottom-3 left-3 rounded-full bg-background-50/90 px-3 py-1 text-xs text-foreground-700 backdrop-blur">
                每日头条 · 编辑精选
              </figcaption>
            </figure>
          </Reveal>
        </div>

        {/* two secondary stories */}
        <div className="mt-10 grid gap-5 sm:grid-cols-2">
          {SECONDARY_STORIES.map((s) => (
            <Reveal key={s.id}>
              <Link
                to={`/read/${s.id}`}
                className="group grid grid-cols-[auto_1fr] items-center gap-4 overflow-hidden rounded-2xl border hairline bg-background-50 p-3 transition-colors hover:border-primary-300"
              >
                <img
                  src={s.cover}
                  alt={s.title}
                  className="h-20 w-24 rounded-xl object-cover object-top md:h-24 md:w-32"
                />
                <div className="min-w-0">
                  <span className="text-xs font-semibold text-accent-700">{s.category}</span>
                  <h3 className="mt-1 line-clamp-2 font-display text-base font-semibold leading-snug text-foreground-950 group-hover:text-primary-700 md:text-lg">
                    {s.title}
                  </h3>
                  <p className="mt-1 hidden text-xs text-foreground-500 sm:block">{s.date}</p>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}